
import axios from 'axios';
import { url } from './url';


function getAIModels({ customer,
    pointId,
    startDate,
    endDate,
    algorithm,
    features, page, pageSize }) {
    var urlString = `${url}/ai-model`;
    return axios
        .get(urlString, {
            params: {
                customer,
                pointId,
                startDate,
                endDate,
                algorithm,
                features,
                pageSize: pageSize,
                page: page
            }
        })
        .then(res => {
            return {
                total: res.data.total,
                models: res.data.models
            };
        });
}
function predict(modelId, measurementId) {
    var urlString = `${url}/ai-model/${modelId}/predict`;
    return axios
        .post(urlString, {
            measurement_id: measurementId
        })
        .then(res => {
            return res.data;
        });
}

function getAIModel(modelId) {
    var urlString = `${url}/ai-model/${modelId}`;
    return axios
        .get(urlString)
        .then(res => {
            return res.data;
        });
}
function createAIModel(data) {
    return axios.post(`${url}/ai-model`, data)
        .then(resp => {
            return resp.data;
        });
}
function saveModelClasses(modelId, classes) {
    return axios.put(`${url}/ai-model/${modelId}/classes`, classes)
        .then(resp => {
            return resp.data;
        });
}
function getAIModelSignedUrl(id) {
    return axios.get(`${url}/ai-model/${id}/model`)
        .then(resp => {
            return resp.data;
        });
}

function getAIReportSignedUrl(id) {
    return axios.get(`${url}/ai-model/${id}/report`)
        .then(resp => {
            return resp.data;
        });
}
function updateAIModelPublishStatus(modelId, published) {
    return axios.put(`${url}/ai-model/${modelId}/published`, { published })
        .then(resp => {
            return resp.data;
        });
}
export default {
    getAIModel,
    getAIModels,
    createAIModel,
    getAIReportSignedUrl,
    getAIModelSignedUrl,
    predict,
    saveModelClasses,
    updateAIModelPublishStatus
};